var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "resizable-card", class: { "no-select": _vm.resizing } },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Job Config")]),
          ]),
          _c(
            "v-card-text",
            [
              _c("r-job-config", {
                attrs: { model: _vm.model },
                on: {
                  "update:model": function ($event) {
                    _vm.model = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.startResize.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }